var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'cards-list',
    `responsive-${_vm.responsive || '1'}`,
    `grid-${_vm.grid || '5'}`,
  ],style:(`gap:${_vm.gap}px`)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }